import { createContext } from 'react'
import type { Review } from './prop_shapes/review'

export interface SupplierState {
  supplierId: Review['supplier_id']
  supplierName: Review['supplier_name']
  logoUrl: Review['supplier_logo_url']
}

export const DEFAULT_SUPPLIER_CONTEXT = {
  supplierId: undefined,
  supplierName: '',
  logoUrl: ''
}

/**
 * Context containing supplier information.
 * Initially this is to pass the supplier's logo url to deeply nested components
 * but can be expanded for other supplier information that might reduce the need for 'prop drilling'
 * where props are opaquely passed through intermediate components.
 */
export const SupplierContext = createContext<SupplierState>(DEFAULT_SUPPLIER_CONTEXT)
